import { ComponentProps, ReactElement } from 'react';
import { CodeNameModel } from 'components/common/types';
import { UsePageFilters } from 'store/pagesFilters/types';
import AsyncSelect from 'lib/AsyncSelect';
import { useLoadLookup } from '../useLoadLookup';
import FilterAsyncLookup from '../FilterAsyncLookup';

export interface FilterSalesTeamProps
  extends Omit<ComponentProps<typeof AsyncSelect>, 'loadData' | 'onSelect' | 'selectedValue' | 'name' | 'textKey'> {
  changeFilters: UsePageFilters<SalesTeamFilterModel>['changeFilters'];
  salesTeam?: CodeNameModel;
}

export interface SalesTeamFilterModel {
  salesTeam: CodeNameModel;
}

const FilterSalesTeam = ({ changeFilters, salesTeam }: FilterSalesTeamProps): ReactElement => {
  const { onLoadSalesTeam } = useLoadLookup();

  return (
    <FilterAsyncLookup
      filterKey="salesTeam"
      selectedValue={salesTeam}
      loadData={onLoadSalesTeam}
      changeFilters={changeFilters}
      placeholder="Search sales team"
      dataTestId="salesTeam-filter"
      pendoLabel="Sales team filter"
    />
  );
};

export default FilterSalesTeam;
